import {SpineConfig} from '@gongxigames/framework/slot';
import {TextStyle} from 'pixi.js';
import {defaultStyle} from 'src/configs/Styles';

const popupIntroTXT1 = {
    style: new TextStyle({...defaultStyle, fontSize: 255}),
    maxWidth: 2700
};
const popupIntroTXT1Config = {
    y: -120
};
const popupIntroTXT2 = {
    style: new TextStyle({...defaultStyle, fontSize: 145})
};
const popupIntroTXT2Config = {
    y: -125
};
const popupIntroTXT3 = {
    style: new TextStyle({...defaultStyle, fontSize: 130})
};
const popupIntroTXT3Config = {
    y: 180
};
const popupRetriggerTXT1 = {
    style: new TextStyle({...defaultStyle, fontSize: 255}),
    maxWidth: 2700
};
const popupRetriggerTXT1Config = {
    y: -120
};
const popupRetriggerTXT2 = {
    style: new TextStyle({...defaultStyle, fontSize: 150})
};
const popupRetriggerTXT2Config = {
    y: -115
};
const popupOutroTXT1 = {
    style: new TextStyle({...defaultStyle, fontSize: 305}),
    maxWidth: 2700
};
const popupOutroTXT1Config = {
    y: -140
};

export const freeGamesTexts: SpineConfig = {
    name: 'popup_texts',
    slots: [
        {...popupIntroTXT1Config, name: 'text_congratulatiuons', text: {...popupIntroTXT1, id: 'popupIntroTXT_1'}},
        {...popupIntroTXT2Config, name: 'freegames', text: {...popupIntroTXT2, id: 'popupIntroTXT_2'}},
        {...popupIntroTXT3Config, name: 'removed', text: {...popupIntroTXT3, id: 'popupIntroTXT_3'}}
    ]
};
export const freeGamesRetriggerTexts: SpineConfig = {
    name: 'popup_texts',
    slots: [
        {...popupRetriggerTXT1Config, name: 'text_congratulatiuons', text: {...popupRetriggerTXT1, id: 'popupIntroTXT_1'}},
        {...popupRetriggerTXT2Config, name: 'freegames', text: {...popupRetriggerTXT2, id: 'popupIntroTXT_2'}}
    ]
};
export const freeGamesOutroTexts: SpineConfig = {
    name: 'popup_texts',
    slots: [
        {...popupOutroTXT1Config, name: 'text_top_winner', text: {...popupOutroTXT1, id: 'popupOutroTXT_1'}}
    ]
};
export const freeGamesBack: SpineConfig = {
    name: 'popup_main'
};
